// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2WshZ","title":"Images90_title__2Mp-3","images":"Images90_images__26NC_"};